import {
  GET_CR_DETAILS_SUCCESS,
  GET_STATES,
  GET_CR_CO_VWO_LIST,
  API_CR_PROFILE,
  API_CR_STATES,
  API_FIND_CO_CR,
} from "../Constants";
import Api, { GET } from "../Api";

export const getCareRecipientDetails = (_id: string, coId?: string) => {
  return (dispatch: any) => {
    Api.GET(
      `${API_CR_PROFILE}${_id}${!coId ? "" : "?co_id=" + coId}`,
      (response) => {
        response &&
          dispatch({
            type: GET_CR_DETAILS_SUCCESS,
            careRecipient: response.data.data,
          });
      },
      false,
      true,
      true
    );
  };
};

export const getStates = () => {
  return (dispatch: any) => {
    GET(API_CR_STATES).then((response) => {
      dispatch({
        type: GET_STATES,
        states: response.data.states,
      });
    });
  };
};

/*export const getLocationFields = () => {
  return (dispatch: any) => {
    GET(API_CR_LOCATION_FIELDS).then((response) => {
      dispatch({
        type: GET_LOCATION_FIELDS,
        locationFields: response.data.locationFields,
      });
    });
  };
};*/

export const getEntities = (type: string) => {
  return (dispatch: any) => {
    Api.POST(
      API_FIND_CO_CR,
      { type },
      (response) => {
        response &&
          dispatch({
            type: GET_CR_CO_VWO_LIST,
            entityList: response.data.filter((v: any) => !!v.name),
          });
      },
      false,
      true
    );
  };
};
